'use strict';
const $ = (selector, scope = document) => scope.querySelector(selector);
const $$ = (selector, scope = document) => [...scope.querySelectorAll(selector)];
const asset = path => {
 const mapped = path.replace(/^assets\/(hero|pink|grey)\.webp$/, 'assets/warming-$1.webp');
 return window.HUGGER_ASSETS?.[path] || mapped;
};
const money = value => new Intl.NumberFormat('en-IE',{style:'currency',currency:window.WARMING_CURRENCY || 'EUR'}).format(value);
const products = {
 socks: { name: 'Super Soft Socks', price: 17.95, old: 29.95, discount: 40 },
 mask: { name: '100% Silk Sleep Mask', price: 27.95, old: 45.95, discount: 39 },
 scrunchie: { name: 'Silk Scrunchie', price: 5.95, old: 17.95, discount: 67 },
 bottle: { name: 'Spare Mini Bottle', price: 5.95, old: 12.95, discount: 54 },
 pillow: { name: '100% Silk Pillowcase', price: 33.95, old: 80.95, discount: 58 },
 pouch: { name: 'Travel Pouch', price: 4.95, old: 11.95, discount: 59 },
 extender: { name: 'Size Extender', price: 8.95, old: 15.95, discount: 44 }
};
for (const [key,product] of Object.entries(products)) { const live=window.WARMING_PRODUCTS[key]; if(live?.variants?.length) { product.price=live.variants[0].price/100;product.old=(live.variants[0].compare_at_price || live.variants[0].price)/100;product.discount=Math.round((1-product.price/product.old)*100); }}
function productCard(key) {
 const product = products[key];
 const article = document.createElement('article');
 article.className = 'product-card';
 article.innerHTML = `<div class="product-visual"><img src="${asset(`assets/${key}.webp`)}" alt="${product.name}" width="332" height="332" loading="lazy"><span class="product-badge">Best Seller</span></div><h3>${product.name}</h3><div class="product-price"><b>${money(product.price)}</b><s>${money(product.old)}</s><span class="discount">${product.discount}% OFF</span></div><button type="button" data-add="${key}">ADD TO CART</button>`;
 return article;
}
['socks', 'mask', 'scrunchie', 'bottle'].forEach(key => $('#stocking-products').append(productCard(key)));
['socks', 'scrunchie', 'pillow', 'mask', 'pouch', 'extender'].forEach(key => $('#other-product-grid').append(productCard(key)));

// The screenshot's clock is the starting value; it never resets to a new offer.
let remaining = 60 * 60 + 57;
setInterval(() => {
 remaining = Math.max(0, remaining - 1);
 $('#countdown').textContent = [Math.floor(remaining / 3600), Math.floor(remaining / 60) % 60, remaining % 60].map(n => String(n).padStart(2, '0')).join(':');
}, 1000);

const colours = { Cream: { label: 'Cream in soft cuddle fur', image: 'hero' }, Grey: { label: 'Grey in soft cuddle fur', image: 'grey' }, Pink: { label: 'Pink in waffle knit', image: 'pink' } };
$$('input[name="colour"]').forEach(input => input.addEventListener('change', () => {
 const selected = colours[input.value];
 $('#colour-name').textContent = selected.label;
 $('#hero-image').src = asset(`assets/${selected.image}.webp`);
 $('#hero-image').alt = `${input.value} Warming Hug with its red hot water bottle`;
 $('.hero').dataset.zoom = asset(`assets/${selected.image}.webp`);
}));
$$('input[name="bundle"]').forEach(input => input.addEventListener('change', () => { $('#bundle-name').textContent = input.value; }));

let lastFocus = null;
function openDialog(dialog) {
 if (dialog.open) return;
 lastFocus = document.activeElement;
 dialog.showModal();
 document.body.style.overflow = 'hidden';
}
function closeDialog(dialog) { dialog.close(); }
$$('dialog').forEach(dialog => {
 $$('.close, .close-drawer', dialog).forEach(button => button.addEventListener('click', () => closeDialog(dialog)));
 dialog.addEventListener('click', event => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeDialog(dialog); } });
 dialog.addEventListener('close', () => { document.body.style.overflow = ''; if (lastFocus && lastFocus.isConnected) lastFocus.focus({ preventScroll: true }); });
});
$('#menu-open').addEventListener('click', () => openDialog($('#navigation')));
$$('#navigation a').forEach(anchor => anchor.addEventListener('click', () => closeDialog($('#navigation'))));
document.addEventListener('click', event => {
 const trigger = event.target.closest('[data-zoom]');
 if (!trigger) return;
 $('#lightbox img').src = trigger.dataset.zoom;
 $('#lightbox img').alt = $('img', trigger)?.alt || 'Product photo';
 openDialog($('#lightbox'));
});
function info(title, content) {
 $('#info-title').textContent = title;
 $('#info-text').textContent = content;
 openDialog($('#info-dialog'));
}
$$('[data-country]').forEach(button => button.addEventListener('click', () => info('Ireland (EUR €)', 'Prices are in euros. Delivering to Ireland.')));
$$('[data-account]').forEach(button => button.addEventListener('click', () => {location.href=(window.WARMING_ROOT || '/')+'account';}));
$$('[data-info]').forEach(button => button.addEventListener('click', () => info(button.dataset.info, 'For help, please contact contact@auraglade.com.')));

let cartBusy=false;
const root=window.WARMING_ROOT || '/';
function showError(error){$('#toast').textContent=error.message || 'Please try again.';$('#toast').classList.add('show');setTimeout(()=>$('#toast').classList.remove('show'),7000);}
async function cartRequest(path,payload){const response=await fetch(root+path,{method:payload?'POST':'GET',headers:payload?{'Content-Type':'application/json','Accept':'application/json'}:{'Accept':'application/json'},body:payload?JSON.stringify(payload):undefined,credentials:'same-origin'});const data=await response.json();if(!response.ok)throw new Error(data.description || data.message || 'Unable to update your bag.');return data;}
async function addItem(item){
 if(cartBusy)return;
 const live=window.WARMING_PRODUCTS;
 const variant=live[item.key]?.variants?.[0] || live.main?.variants?.find(v=>`${v.options[0]}-${v.options[1]}`===item.key);
 if(!variant){showError(new Error('This option is currently unavailable. Please contact support.'));return;}
 cartBusy=true;$('#add-main').disabled=true;
 try{await cartRequest('cart/add.js',{items:[{id:variant.id,quantity:1}]});await renderCart();openDialog($('#cart'));}
 catch(error){showError(error);}finally{cartBusy=false;$('#add-main').disabled=false;}
}
async function changeLine(key,quantity){if(cartBusy)return;cartBusy=true;try{const cart=await cartRequest('cart/change.js',{id:key,quantity});drawCart(cart);}catch(error){showError(error);}finally{cartBusy=false;}}
async function renderCart(){const cart=await cartRequest('cart.js');drawCart(cart);return cart;}
function drawCart(cart){
 const quantity=cart.item_count;
 $('#cart-count').hidden=!quantity;$('#cart-count').textContent=quantity;$('#drawer-count').textContent=quantity;
 $('#cart-open').setAttribute('aria-label',`Open shopping bag, ${quantity} items`);
 $('#cart-total').textContent=money(cart.total_price/100);
 const target=$('#cart-items');target.replaceChildren();
 if(!cart.items.length){const empty=document.createElement('p');empty.textContent='Your cart is empty';target.append(empty);}
 $('#checkout-button').disabled=!quantity;
 for(const item of cart.items){
  const article=document.createElement('article');article.className='cart-item';
  const image=document.createElement('img');image.src=item.image || '';image.alt=item.product_title;
  const details=document.createElement('div'),title=document.createElement('h3');title.textContent=item.product_title;
  const variant=document.createElement('small');variant.textContent=item.variant_title==='Default Title'?'':item.variant_title;
  const row=document.createElement('div');row.className='cart-quantity';
  const stepper=document.createElement('span');stepper.className='stepper';
  for(const [index,delta] of [-1,1].entries()){
   if(index===1){const count=document.createElement('span');count.textContent=item.quantity;stepper.append(count);}
   const button=document.createElement('button');button.textContent=delta===-1?'−':'+';button.setAttribute('aria-label',`${delta===-1?'Remove one':'Add one'} ${item.product_title}`);button.addEventListener('click',()=>changeLine(item.key,item.quantity+delta));stepper.append(button);
  }
  const price=document.createElement('b');price.textContent=money(item.final_line_price/100);row.append(stepper,price);
  const remove=document.createElement('button');remove.textContent='Remove';remove.addEventListener('click',()=>changeLine(item.key,0));
  details.append(title,variant,row,remove);article.append(image,details);target.append(article);
 }
}

$('#cart-open').addEventListener('click', () => { renderCart().catch(showError); openDialog($('#cart')); });
$('#add-main').addEventListener('click', () => {
 const colour = $('input[name="colour"]:checked').value;
 const bundle = $('input[name="bundle"]:checked').value;
 addItem({ key: `${colour}-${bundle}`, name: 'Warming Hug', variant: `${colour} / ${bundle}`, price: bundle === 'Standard' ? 34.95 : 44.95, image: asset(`assets/${colours[colour].image}.webp`) });
});
document.addEventListener('click', event => {
 const trigger = event.target.closest('[data-add]');
 if (!trigger) return;
 const key = trigger.dataset.add;
 addItem({ key, ...products[key], image: asset(`assets/${key}.webp`) });
});
$('#customer-toggle').addEventListener('click', event => {
 const expanded = event.currentTarget.getAttribute('aria-expanded') === 'true';
 event.currentTarget.setAttribute('aria-expanded', String(!expanded));
 $('#customer-content').hidden = expanded;
 $('.round-arrow', event.currentTarget).textContent = expanded ? '⌄' : '⌃';
});
const quotes = [
 { title: "I'm Obsessed", text: 'This really is soooo good! I was surprised at how good the quality of the material is and it’s so lovely and soft.', author: 'Caroline' },
 { title: 'She Loves It!', text: 'My girlfriend absolutely loves this. Hasn’t taken it off lol.', author: 'Lee V' }
];
$$('.quote-dots button').forEach((button, index) => button.addEventListener('click', () => {
 const quote = quotes[index];
 $('#quote-title').textContent = quote.title; $('#quote-text').textContent = quote.text; $('#quote-author').textContent = quote.author;
 $$('.quote-dots button').forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === index)));
}));

// The first ten entries transcribe the supplied screenshot. Additional entries
// are from the original page, retained in reference/sources.json and README.md.
const reviewPages = [
 [
  ['JULIE CHIRON', 'Perfect', 'Perfect for endometriosis pain!!!'],
  ['ELAINE Christie-GRIFFITHS', 'Warming Hug', 'Item as described. Fast delivery. Great service'],
  ['William Fraser', 'Instant relief', 'I purchased for my daughter. She benefited immediately from Warming Hug.'],
  ['Michael Lysaght', '', 'Warming Hug'],
  ['Marco Rinaldi', '', 'My girlfriend loved it!'],
  ['Rick Phillips', 'Great', 'How did i ever cope without it! Use it every morning for my bad back. Great product!'],
  ['Kieran Jones', 'Great product', 'My daughter loves it.'],
  ['Graham Cook', 'Really cool', 'Keeps all places warm'],
  ['Kate Gliddon', 'Warming Hug', 'Simple to order, received items quickly, they look great but unable to test as presents for family'],
  ['Riki Spencer', 'Great product daughter is very happy', "Fantastic product can't recomend enough"]
 ],
 [
  ['Anthony Taylor', 'Perfect Product.', 'This is very soft and comfortable to wear - keeps you very warm and is very good at eliminating cramps! Excellent.'],
  ['Sophie Henderson', 'I’m obsessed!', 'This really is soooo good! I was surprised at how good the quality of the material is and it’s so lovely and soft. I wear it all day with the little hot water bottle on the front or the back depending on what my body wants!']
 ],
 [
  ['Jamie McCarthy', 'Ideal product', "I bought the Warming Hug for my partner and she loves it. It's soothing, comfortable and fits nicely under baggy clothing."],
  ['Chris West', 'Nice and warm', 'Great little gift for the wife, have you ever thought about doing kids sizes']
 ]
];
let activePage = 1;
const localReviews = [];
function renderReviews() {
 const entries = reviewPages[activePage - 1].map(row => ({ name: row[0], title: row[1], body: row[2], rating: 5, verified: true }));
 if (activePage === 1) entries.unshift(...localReviews);
 const order = $('#review-sort').value;
 if (order !== 'recent') entries.sort((a, b) => order === 'highest' ? b.rating - a.rating : a.rating - b.rating);
 $('#review-list').replaceChildren();
 entries.forEach(review => {
  const article = document.createElement('article'); article.className = 'review-entry';
  const stars = document.createElement('p'); stars.className = 'stars'; stars.textContent = '★'.repeat(review.rating) + '☆'.repeat(5 - review.rating); stars.setAttribute('aria-label', `${review.rating} out of 5 stars`);
  const nameRow = document.createElement('div'); nameRow.className = 'review-name';
  const avatar = document.createElement('span'); avatar.className = 'avatar'; avatar.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="7" r="3"/><path d="M5 22v-4c0-6 14-6 14 0v4"/></svg>';
  const name = document.createElement('span'); name.textContent = review.name; nameRow.append(avatar, name);
  if (review.verified) { const verified = document.createElement('span'); verified.className = 'verified-tag'; verified.textContent = 'Verified'; nameRow.append(verified); }
  article.append(stars, nameRow);
  if (review.title) { const title = document.createElement('h3'); title.textContent = review.title; article.append(title); }
  const body = document.createElement('p'); body.className = 'review-body'; body.textContent = review.body; article.append(body);
  $('#review-list').append(article);
 });
 $$('.pagination button').forEach(button => { const selected = button.dataset.page === String(activePage); button.classList.toggle('active', selected); if (selected) button.setAttribute('aria-current', 'page'); else button.removeAttribute('aria-current'); });
}
$$('.pagination button').forEach(button => button.addEventListener('click', () => {
 activePage = button.dataset.page === 'next' ? Math.min(3, activePage + 1) : button.dataset.page === 'last' ? 3 : Number(button.dataset.page);
 renderReviews(); $('.sort-label').scrollIntoView({ block: 'start', behavior: 'smooth' });
}));
$('#review-sort').addEventListener('change', renderReviews);
$('#review-open').addEventListener('click', () => { location.href='mailto:contact@auraglade.com?subject=Warming%20Hug%20review'; });
$('#review-form').addEventListener('submit', event => {
 event.preventDefault();
 const data = new FormData(event.currentTarget);
 localReviews.unshift({ name: data.get('name').trim(), title: data.get('title').trim(), body: data.get('review').trim(), rating: Number(data.get('rating')), verified: false });
 activePage = 1; $('#review-sort').value = 'recent'; renderReviews(); closeDialog($('#review-dialog')); event.currentTarget.reset();
 $('#toast').textContent = 'Your demonstration review has been added to this page.'; $('#toast').classList.add('show'); setTimeout(() => $('#toast').classList.remove('show'), 4000);
});
renderReviews();
renderCart().catch(showError);

$('#checkout-button')?.addEventListener('click',()=>{location.href=(window.WARMING_ROOT || '/')+'checkout';});

function updateOfferPrices(){const colour=$('input[name="colour"]:checked')?.value;for(const [name,selector] of [['Standard','.standard'],['Cozy Bundle','.cozy']]){const v=window.WARMING_PRODUCTS.main?.variants?.find(v=>v.options[0]===colour&&v.options[1]===name);if(v){$(selector+' .price b').textContent=money(v.price/100);const old=$(selector+' .price s');old.textContent=v.compare_at_price?money(v.compare_at_price/100):'';}}}
$$('input[name="colour"]').forEach(input=>input.addEventListener('change',updateOfferPrices));updateOfferPrices();
